import createLogger from '@/lib/logger'

import type { RouteLocationNormalized } from 'vue-router'

const logger = createLogger('undefinedRouteGuard')

/**
 * Handles non existent page urls
 */
export const undefinedRouteGuard = async (to: RouteLocationNormalized) => {
  logger.log('Running hook...')

  // Check if the route actually exists by verifying it has a valid component and name
  // For undefined routes, the matched route will have no name or an invalid component
  const isRouteValid =
    (to.name &&
      to.matched.length > 0 &&
      to.matched.some((record) => record.components?.default)) ||
    to.path === '/'

  if (!isRouteValid) {
    logger.log('Route does not exist, redirecting to new chat...')
    return { name: 'NewChat', query: to.query }
  }
}
